export const GET_ATTORNEYS = {
  START: "ATTORNEYS/GET_ATTORNEYS_START",
  SUCCESS: "ATTORNEYS/GET_ATTORNEYS_SUCCESS",
  ERROR: "ATTORNEYS/GET_ATTORNEYS_ERROR",
};
